import React from "react";
import ReactECharts from "echarts-for-react";

const EnergySourcePieChart: React.FC = () => {
  const options = {
    tooltip: {
      trigger: "item",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      formatter: "{a} <br/>{b} : {c} kWh ({d}%)",
    },
    grid: {
      left: "1%",
      right: "1%",
      top: "10%",
      bottom: "10%",
    },
    legend: {
      orient: "vertical",
      left: "right",
      top: "middle",
      data: ["Renewable", "Non-Renewable"],
      textStyle: {
        fontSize: 10,
        color: "#5F6368",
      },
    },
    series: [
      {
        name: "Energy Type",
        type: "pie",
        radius: "95%",
        data: [
          { value: 70, name: "Renewable", itemStyle: { color: "#9CE976" } },
          { value: 30, name: "Non-Renewable", itemStyle: { color: "#1976d2" } },
        ],
      },
    ],
  };

  return <ReactECharts option={options} />;
};

export default EnergySourcePieChart;
